export default __webpack_public_path__ + "static/media/header-photo.848d3f29.png";